'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _class, _temp2;

var _AsyncTypeahead = require('react-bootstrap-typeahead/lib/AsyncTypeahead.react');

var _AsyncTypeahead2 = _interopRequireDefault(_AsyncTypeahead);

var _Menu = require('react-bootstrap-typeahead/lib/Menu.react');

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = require('react-bootstrap-typeahead/lib/MenuItem.react');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _search = require('../../redux/modules/search');

var _searchParams = require('../../utils/searchParams');

var _searchSuggestions = require('../../redux/modules/searchSuggestions');

var _urls = require('../../utils/urls');

var _whiteLabel = require('../../redux/modules/whiteLabel');

var _reactIntl = require('@liveauctioneers/react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem3 = require('react-bootstrap/lib/MenuItem');

var _MenuItem4 = _interopRequireDefault(_MenuItem3);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _route = require('../../redux/modules/route');

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _headerSearchDropdown = require('../../redux/modules/headerSearchDropdown');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = require('react-router-redux');

var _SearchInput = require('./SearchInput.scss');

var _SearchInput2 = _interopRequireDefault(_SearchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuHeader = function MenuHeader(props) {
    return _react2.default.createElement('span', (0, _extends3.default)({}, props, { className: _SearchInput2.default['auction-house-divider'] }));
};

var mapStateToProps = function mapStateToProps(state) {
    var pageSize = (0, _search.getSearchPageSize)(state);
    var isBuyNow = (0, _search.getIsBuyNow)(state);
    var archivedSearchGlobalState = (0, _search.isArchivedSearch)(state) && !isBuyNow;
    var currentUrl = (0, _route.getCurrentUrlFromState)(state);
    var isLoading = (0, _searchSuggestions.getSearchSuggestionsLoading)(state);
    var isOnSearchPage = currentUrl.includes('/search');
    var dropdownVisible = isOnSearchPage && archivedSearchGlobalState && (0, _headerSearchDropdown.isHeaderDropdownVisible)(state);
    var suggestions = (0, _searchSuggestions.getSearchSuggestions)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    var sellerId = (0, _whiteLabel.getWhiteLabelSellerId)(state);

    return {
        archivedSearchGlobalState: archivedSearchGlobalState,
        dropdownVisible: dropdownVisible,
        isLoading: isLoading,
        pageSize: pageSize,
        sellerId: sellerId,
        suggestions: suggestions,
        whiteLabel: whiteLabel
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchSearchSuggestions: _searchSuggestions.fetchSearchSuggestions,
        push: _reactRouterRedux.push
    }, dispatch);
};

var SearchInput = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(SearchInput, _Component);

    function SearchInput() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SearchInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchInput.__proto__ || (0, _getPrototypeOf2.default)(SearchInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            archiveSearchStatus: _this.props.archivedSearchGlobalState,
            dropdownVisible: _this.props.dropdownVisible,
            isMenuOpen: false,
            selected: [],
            text: ''
        }, _this.shouldComponentUpdate = function (nextProps, nextState) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps) || !(0, _reactFastCompare2.default)(_this.state, nextState);
        }, _this.onKeyUp = function (event) {
            if (event.keyCode === 13) {
                _this.search();
            }
        }, _this.onToggle = function () {
            _this.setState({
                isMenuOpen: !_this.state.isMenuOpen
            });
        }, _this.searchPhrase = function (keyword) {
            var searchStatus = _this.state.archiveSearchStatus || _this.props.forceArchiveOnly ? _searchParams.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH : _searchParams.DEFAULT_STATUS_FOR_ONLINE_SEARCH;

            var params = {
                keyword: keyword,
                sort: _search.DEFAULT_SORT_ORDER,
                status: searchStatus
            };

            if (_this.props.whiteLabel) {
                params.house_id = '' + _this.props.sellerId;
            }

            var search = (0, _urls.getSearchUrlWithParams)(params);

            _this.props.push(search);
            var instance = _this._typeahead.getInstance();
            instance.blur();
        }, _this.searchHouse = function (houseId, houseName) {
            _this.props.push({
                pathname: (0, _urls.getSellerUrl)(houseId, houseName)
            });
        }, _this.search = function () {
            var selected = _this.state.selected.length > 0 ? _this.state.selected[0] : null;
            if (selected) {
                if (selected.houseId) {
                    _this.searchHouse(selected.houseId, selected.value);
                } else {
                    _this.searchPhrase(selected.value);
                }
            } else {
                if (_this.state.text.trim().length === 0) {
                    return;
                }
                _this.searchPhrase(_this.state.text.trim());
            }
        }, _this.addHousesHeader = function (suggestions) {
            if (!suggestions || !suggestions.length) return undefined;
            if (suggestions.some(function (suggestion) {
                return suggestion.label === 'Auction Houses';
            })) return suggestions;
            var catalogIndex = suggestions.findIndex(function (result) {
                return result.houseId;
            });
            if (catalogIndex > -1) {
                suggestions.splice(catalogIndex, 0, {
                    label: 'Auction Houses',
                    value: 'Auction Houses'
                });
            }
            return suggestions;
        }, _this.handleChange = function (selected) {
            var selectedItem = selected && selected.length && selected[0].value ? selected[0] : null;

            if (selectedItem) {
                if (selectedItem.label === 'Auction Houses') return;
                if (selectedItem.houseId) {
                    _this.searchHouse(selectedItem.houseId, selectedItem.value);
                } else {
                    _this.searchPhrase(selectedItem.value);
                }
            }
        }, _this.handleInputChange = function (text) {
            return _this.setState({ text: text });
        }, _this.handleSearch = function (query) {
            return _this.props.fetchSearchSuggestions(query);
        }, _this.buildMenuItems = function (items, term, index) {
            var menuItems = [];
            items.forEach(function (item) {
                try {
                    var regularExpression = new RegExp('(' + term + ')', 'gi');
                    var menuItem = (0, _jsx3.default)(_MenuItem2.default, {
                        option: item,
                        position: index
                    }, index, (0, _jsx3.default)('span', {
                        className: _SearchInput2.default['suggestions-result'],
                        dangerouslySetInnerHTML: {
                            __html: item.label.replace(regularExpression, '<span class="' + _SearchInput2.default['query-match'] + '">$1</span>')
                        }
                    }));
                    index += 1;
                    menuItems.push(menuItem);
                } catch (error) {
                    console.warn('Error building menu items with error', error);
                }
            });
            return menuItems;
        }, _this.changeSearchStatus = function () {
            return _this.setState({ archiveSearchStatus: !_this.state.archiveSearchStatus });
        }, _this.renderSuggestions = function (results, props) {
            var term = _this.state.text;
            var items = [];
            var auctionHouses = [];
            var grouped = results.reduce(function (refinedResult, result) {
                if (result.label === 'Auction Houses') return refinedResult;
                if (result.houseId) {
                    refinedResult.auctionHouses.push(result);
                } else {
                    refinedResult.auctionItems.push(result);
                }
                return refinedResult;
            }, { auctionHouses: [], auctionItems: [] });

            // reduce popular search suggestions for items to 5
            if (grouped.auctionItems.length > 5) {
                grouped.auctionItems = grouped.auctionItems.slice(0, 5);
            }

            items = _this.buildMenuItems(grouped.auctionItems, term, 0);
            if (grouped.auctionHouses.length > 0) {
                var auctionHouseHeader = (0, _jsx3.default)('div', {
                    className: _SearchInput2.default['auction-house-wrapper']
                }, 'auction-house-wrapper', (0, _jsx3.default)(MenuHeader, {}, 'auctionHouse' + '-header', 'Auction Houses'), (0, _jsx3.default)('span', {
                    className: _SearchInput2.default['auction-house-line']
                }));

                if (!_this.state.archiveSearchStatus) {
                    var auctionHouse = _this.buildMenuItems(grouped.auctionHouses, term, 5);
                    auctionHouses = [auctionHouseHeader].concat((0, _toConsumableArray3.default)(auctionHouse));
                } else {
                    auctionHouses = [];
                }
            }
            return _react2.default.createElement(
                _Menu2.default,
                props,
                [].concat((0, _toConsumableArray3.default)(items), (0, _toConsumableArray3.default)(auctionHouses))
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SearchInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // checking prop changes to ensure the right option on the dropdown is shown
            if (this.props.dropdownVisible && !prevProps.archivedSearchGlobalState || !this.props.dropdownVisible && prevProps.archivedSearchGlobalState) {
                this.setState({ archiveSearchStatus: this.props.archivedSearchGlobalState });
            }

            // checking prop changes to ensure that the dropdown is still visible when you select upcoming
            if (this.state.archiveSearchStatus && !this.props.dropdownVisible || this.props.dropdownVisible) {
                this.setState({ dropdownVisible: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                intl = _props.intl,
                isLoading = _props.isLoading,
                _props$suggestions = _props.suggestions,
                suggestions = _props$suggestions === undefined ? [] : _props$suggestions,
                whiteLabel = _props.whiteLabel;
            var _state = this.state,
                archiveSearchStatus = _state.archiveSearchStatus,
                dropdownVisible = _state.dropdownVisible;
            var formatMessage = intl.formatMessage;


            var title = formatMessage({
                id: archiveSearchStatus ? 'search_input_sold' : 'search_input_upcoming'
            });
            var item = formatMessage({
                id: archiveSearchStatus ? 'search_input_upcoming' : 'search_input_sold'
            });

            var classes = (0, _classnames2.default)(_SearchInput2.default['search-input'], className);
            var searchBarClass = dropdownVisible ? _SearchInput2.default['search-bar-input'] : _SearchInput2.default['search-bar-input-with-dropdown'];
            var extraClass = this.state.isMenuOpen ? _SearchInput2.default['remove-bottom-border'] : '';

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, dropdownVisible && (0, _jsx3.default)('div', {
                className: _SearchInput2.default['search-dropdown'] + ' ' + extraClass
            }, void 0, (0, _jsx3.default)(_DropdownButton2.default, {
                className: _SearchInput2.default['search-field-dropdown'],
                title: title,
                onSelect: this.changeSearchStatus,
                onToggle: this.onToggle,
                id: 'search-input-dropdown'
            }, '1', (0, _jsx3.default)(_MenuItem4.default, {
                eventKey: '1'
            }, void 0, item))), _react2.default.createElement(_AsyncTypeahead2.default, {
                className: searchBarClass,
                delay: 300,
                emptyLabel: '',
                filterBy: function filterBy() {
                    return true;
                },
                isLoading: isLoading,
                labelKey: 'value',
                menuId: this.props.name,
                minLength: 1,
                onChange: this.handleChange,
                onInputChange: this.handleInputChange,
                onKeyDown: this.onKeyUp,
                onSearch: this.handleSearch,
                options: whiteLabel ? [] : this.addHousesHeader(suggestions),
                placeholder: formatMessage({
                    id: archiveSearchStatus ? 'search_input_search_past_auction_price_results' : 'search_input_search_for_items_and_auction_houses'
                }),
                promptText: '',
                ref: function ref(_ref2) {
                    _this2._typeahead = _ref2;
                },
                renderMenu: this.renderSuggestions,
                selected: this.state.selected,
                useCache: false
            }), (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                className: _SearchInput2.default['search-field-icon'],
                icon: ['fas', 'search'],
                onClick: this.search
            }));
        }
    }]);
    return SearchInput;
}(_react.Component), _class.defaultProps = {
    className: '',
    suggestions: []
}, _temp2);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.withIntlContext)(SearchInput));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchInput.js
// module id = LXPM
// module chunks = 60